import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import PageNotFound from "./utils/PageNotFound"
import Home from "./components/Pages/Home";
import Students from "./components/Pages/Students";

function App() {
  return (
    <BrowserRouter>
      <Routes element={<Layout />}>
        <Route exact path="/*" element={<PageNotFound />} />
        <Route exact path="/dashboard" element={<Home />} />
        <Route index path="/students" element={<Students />} />
        <Route path="/" element={<Navigate to="/students" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
